import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c9b7dac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "one_c" }
const _hoisted_2 = { class: "form-grid" }
const _hoisted_3 = { class: "flex justify-end mt-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.data)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "xxl",
          title: "Данные заказа",
          onCancel: _ctx.toggleData,
          scrollable: "",
          "without-footer": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("pre", null, _toDisplayString(_ctx.state.data), 1)
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.loadSdt(1)), ["prevent"])),
        class: "one_c__form"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_the_input, {
            type: "date",
            placeholder: "Дата от",
            value: _ctx.state.createdAtFrom,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.createdAtFrom) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadSdt(1)))
          }, null, 8, ["value"]),
          _createVNode(_component_the_input, {
            type: "date",
            placeholder: "Дата до",
            value: _ctx.state.createdAtTo,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.createdAtTo) = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadSdt(1)))
          }, null, 8, ["value"]),
          _createVNode(_component_the_input, {
            placeholder: "Номер накладной",
            value: _ctx.state.invoiceNumber,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.invoiceNumber) = $event)),
            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadSdt(1)))
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_the_button, {
            class: "second text small",
            loading: _ctx.state.is_loading,
            onClick: _ctx.reset
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]),
          (_ctx.havePermissions(['sdt-order.create', 'all-root-permission']))
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 0,
                class: "primary small ml-2",
                loading: _ctx.state.is_loading,
                onClick: _ctx.resend
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Прокинуть ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_the_button, {
            class: "primary small ml-2",
            loading: _ctx.state.is_loading,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Поиск ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_5, [
        (
                    _ctx.data_state.sdt_orders.is_failed &&
                    !_ctx.data_state.sdt_orders.failure.error_state.is_cancel
                )
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.data_state.sdt_orders.is_loading,
              text: "При получении истории заказов произошла ошибка",
              "error-message": _ctx.data_state.sdt_orders.failure.error_state.message,
              "error-url": _ctx.data_state.sdt_orders.failure.error_state.url,
              "error-status": _ctx.data_state.sdt_orders.failure.error_state.status,
              onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadSdt(_ctx.data_state.sdt_orders.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
              key: 1,
              loading: _ctx.data_state.sdt_orders.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.data_state.sdt_orders.is_loading,
                  columns: _ctx.SdtColumns,
                  rows: _ctx.data_state.sdt_orders.list,
                  "with-limit": "",
                  "pagination-limit": _ctx.state.limit,
                  "pagination-total-items": _ctx.data_state.sdt_orders.pagination.total_items,
                  "pagination-current-page": _ctx.data_state.sdt_orders.pagination.current_page,
                  "pagination-total-pages": _ctx.data_state.sdt_orders.pagination.total_pages,
                  "is-wrap": "",
                  onChangePage: _ctx.loadSdt,
                  onChangeLimit: _ctx.onLimitChange
                }, {
                  actions: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_the_button, {
                        hint: "Данные заказа",
                        class: "primary extra-small",
                        onClick: ($event: any) => (_ctx.toggleData(row.data)),
                        loading: _ctx.state.is_loading,
                        disabled: _ctx.state.is_loading
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick", "loading", "disabled"]),
                      (_ctx.havePermissions(['sdt-order.create', 'all-root-permission']))
                        ? (_openBlock(), _createBlock(_component_the_button, {
                            key: 0,
                            hint: "Переотправить заказ",
                            class: "primary extra-small ml-2",
                            onClick: ($event: any) => (_ctx.resendSdtOrder(row.id)),
                            loading: _ctx.state.is_loading,
                            disabled: _ctx.state.is_loading
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 2
                          }, 1032, ["onClick", "loading", "disabled"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  td: _withCtx(({ row, column }) => [
                    (column.key === 'createdAt')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(row.createdAt)), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ])
  ], 64))
}